
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-service-point",
  components: {},
})
export class IconServicePoint extends Vue {
  @Prop({ default: 80 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
  @Prop({ default: "#ffd102" }) public color2!: string;

  constructor() {
    super();
  }
}
export default IconServicePoint;
